export default "__VITE_ASSET__BQRwAQug__"